import PageWrapper from '@/components/page-wrapper'
import Banner from './banner'
import Solution from './solution'

export default function Index() {
  return (
    <PageWrapper soul darkHeader>
      <Banner />
      <Solution />
    </PageWrapper>
  )
}
